import { Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { SurveyDeployerConfigResponseJSON } from "./common/JSON/surveyConfig/Survey-Deployer-Config-Response-JSON";
import { SurveyDeployerWCPageRequestJSON } from "./common/JSON/RequestTOJSON/Survey-Deployer-WC-Page-Request.JSON";

@Injectable()
export class RequestService{
    surveyStatus: Number;
    surveyDeployerConfigResponseJSON:SurveyDeployerConfigResponseJSON;
    surveyDeployerWCPageRequestJSON:SurveyDeployerWCPageRequestJSON;
    email:string;
    username:string;
    mobileNumber:Number;
    companyName:String;
    surveyUserGeneratedID:Number;
    employeeCode:String;

    constructor(private http:HttpClient){}

    getData(){
        return this.http.get("http://www.mocky.io/v2/594cf06d1100009f22a3d1d8")
                    
    }

    setConfig(input){
        this.surveyDeployerConfigResponseJSON=input;
    }

    getConfig(){
        return this.surveyDeployerConfigResponseJSON;
    }

    setSurveyDeployerWCPageRequestJSON(surveyDeployerWCPageRequestJSON){
        this.surveyDeployerWCPageRequestJSON=surveyDeployerWCPageRequestJSON;
    }

    getSurveyDeployerWCPageRequestJSON(){
        return this.surveyDeployerWCPageRequestJSON;
    }

    setUsernameEmailCompanyMobile(username, email, companyName, mobileNumber, surveyStatus, surveyUserGeneratedID, employeeCode){
        this.username=username;
        this.email=email;
        this.companyName=companyName;
        this.mobileNumber=mobileNumber;
        this.surveyStatus = surveyStatus;
        this.surveyUserGeneratedID = surveyUserGeneratedID;
        this.employeeCode = employeeCode;
    }

    getUsername(){
        return this.username;
    }

    getEmail(){
        return this.email;
    }

    getMobileNumber(){
        return this.mobileNumber;
    }

    getCompanyName(){
        return this.companyName;
    }

    getSurveyUserGeneratedID(){
        return this.surveyUserGeneratedID;
    }

    getSurveyStatus(): any {
        return this.surveyStatus;
    }

    getEmployeeCode(): any {
        return this.employeeCode;
    }
}